import {
  Feedback,
  FEEDBACK_PRIORITY,
  FeedbackImage,
  RefModelNode,
  Requirement,
  STATUS_CATEGORIES,
  Story
} from '@q9elements/ui-kit/common';

export interface BaseGridFeedback extends Omit<Feedback, 'replies' | 'parent'> {
  replies: number;
  userGroups: string;
  parent?: {
    id: string;
    name: string;
  };
  recordType?: {
    name: string;
    url: string;
  };
  links: FeedbackLinks[];
}

export interface FeedbackAttachment {
  _id: string;
  linkId: string;
  title: string;
  type: string;
  story?: Story;
  requirement?: Requirement;
}

export interface FeedbackLinks {
  item:
    | (Partial<Story> & {parentType: string; parentId: string; childId: string})
    | (Partial<Requirement> & {parentType: string; parentId: string; childId: string});
  type: FeedbackChangeType;
  _id: string;
}

export interface SfNodeFeedback extends BaseGridFeedback {
  refModelNode: RefModelNode;
  name: string;
}

export interface RefModelNodeFeedback extends BaseGridFeedback {}

export interface DiagramActivityFeedback extends Omit<BaseGridFeedback, 'parent'> {
  parent: {
    id: string;
    name: string;
    state: 'active' | 'deleted';
  };
}

export interface UrlLibraryFeedback extends Omit<BaseGridFeedback, 'parent'> {}

export type GridFeedback =
  | BaseGridFeedback
  | SfNodeFeedback
  | RefModelNodeFeedback
  | DiagramActivityFeedback
  | UrlLibraryFeedback;

export const FEEDBACK_PRIORITY_LABELS = {
  [FEEDBACK_PRIORITY.None]: 'None',
  [FEEDBACK_PRIORITY.Low]: 'Low',
  [FEEDBACK_PRIORITY.Medium]: 'Medium',
  [FEEDBACK_PRIORITY.High]: 'High'
};

export enum FEEDBACK_TABS {
  ACTIVE = 'active',
  CLOSED = 'closed'
}

export interface FeedbackMeta {
  _id: string;
  id: string;
  images: FeedbackImage[];
}

export enum FeedbackChangeState {
  OPEN = 'open',
  CLOSED = 'closed'
}

export enum ActiveStateCategory {
  OPEN_WITH_ORIGINATOR = STATUS_CATEGORIES.OPEN_WITH_ORIGINATOR,
  OPEN = STATUS_CATEGORIES.OPEN,
  MANAGED = STATUS_CATEGORIES.MANAGED
}

export enum ClosedStateCategory {
  CLOSED = STATUS_CATEGORIES.CLOSED,
  CLOSED_IMPLEMENTED = STATUS_CATEGORIES.CLOSED_IMPLEMENTED
}

export enum FeedbackChangeType {
  STORY = 'story',
  REQUIREMENT = 'requirement'
}

export const stateCategoryObject: {
  active: ActiveStateCategory[];
  closed: ClosedStateCategory[];
} = {
  active: [
    ActiveStateCategory.OPEN_WITH_ORIGINATOR,
    ActiveStateCategory.OPEN,
    ActiveStateCategory.MANAGED
  ],
  closed: [ClosedStateCategory.CLOSED, ClosedStateCategory.CLOSED_IMPLEMENTED]
};
